import EmpReport from "./empReport";
import { withApi } from "../ApiWrapper";
import "./styles.scss";

export default withApi(EmpReport);
